import React from 'react'
import { SocialButton } from './SocialButton'
const MAX_TWEET_LENGTH = 280
const SHORTENED_URL_LENGTH = 23
const FILLER_COUNT = 8

export const ShareOnTwitter = ({ frontmatter, ...rest }) => {
  let tweetContent = frontmatter.language === 'de'
    ? 'Ich habe da ein cooles Tutorial bei Hetzner gefunden. Schaut doch mal rein:'
    : 'I found a cool tutorial at Hetzner. Check it out: '
  tweetContent += `\n\n${ frontmatter.title }\n\n`

  const hashtags = ['hetznertutorial', ...frontmatter.tags.slice(0, 3)]
    .map(tag => tag.replace(/\s/, ''))
    .map(tag => encodeURI(tag))
    .join(',')

  const tweetLength = tweetContent.length + SHORTENED_URL_LENGTH + hashtags.length + 'via @Hetzner_Online'.length + FILLER_COUNT
  const contentOverflow = tweetLength - MAX_TWEET_LENGTH
  if (contentOverflow > 0) {
    tweetContent = tweetContent.substr(0, tweetContent.length - contentOverflow)
  }

  const urlEncodedTweetContent = encodeURI(tweetContent)
  const urlEncodedTutorialUrl = encodeURI(`https://community.hetzner.com${ frontmatter.path }`)
  const via = encodeURI('Hetzner_Online')

  return (
    <SocialButton
      as={'a'}
      target={'_blank'}
      rel={'noopener noreferrer'}
      className='d-flex link-unstyled box-shadow-none'
      href={`https://twitter.com/intent/tweet?text=${ urlEncodedTweetContent }&url=${ urlEncodedTutorialUrl }&hashtags=${ hashtags }&via=${ via }`}
      { ...rest }
    >
      <img height={14} width={14} src={require("../../../images/x-icon.svg").default} alt="x-icon"/>
    </SocialButton>
  )
}
